module.exports = __webpack_public_path__ + "files/4f5f03280dcd6981eb6f86526788dbc1.png";